import { render, staticRenderFns } from "./TileCurrentProductQuantity.vue?vue&type=template&id=245a82f8"
import script from "./TileCurrentProductQuantity.vue?vue&type=script&lang=js"
export * from "./TileCurrentProductQuantity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports